import React from "react";
import { MapPin, ExternalLink } from "lucide-react";
import FavHeart from "./FavHeart";
import ShareButton from "./ShareButton";
import { formatDate } from "../lib/format";

export default function EventCard({ event }) {
  const { id, name, description, feature_image, date, location, type, news_url } = event;
  const year = date ? new Date(date).getFullYear() : "";
  return (
    <div className="sat-surface sat-brackets p-0 grid grid-cols-1 md:grid-cols-[100px_1fr] gap-0" data-testid={`event-card-${id}`}>
      <div className="p-5 border-b md:border-b-0 md:border-r border-[color:var(--sat-border)] bg-black/60">
        <div className="sat-label sat-cyan">YEAR</div>
        <div className="font-display font-bold text-3xl sat-cyan sat-glow mt-2">{year}</div>
      </div>
      <div className="p-5 flex flex-col md:flex-row gap-4">
        {feature_image && (
          <div className="w-full md:w-40 h-32 md:h-24 flex-shrink-0 overflow-hidden bg-black">
            <img src={feature_image} alt={name} loading="lazy" className="w-full h-full object-cover opacity-80" />
          </div>
        )}
        <div className="flex-1 flex flex-col gap-2">
          <div className="flex items-center justify-between gap-2">
            <span className="sat-label sat-cyan">{type?.name?.toUpperCase() || "EVENT"}</span>
            <div className="flex items-center gap-1.5">
              <ShareButton url={news_url || (typeof window !== "undefined" ? window.location.href : "")} title={name} size={12} testid={`event-share-${id}`} />
              <FavHeart kind="event" ref_id={id} title={name} image={feature_image} payload={{ date, news_url }} size={13} />
            </div>
          </div>
          <h3 className="font-display font-bold text-lg leading-tight">{name}</h3>
          {description && <p className="text-sm text-[color:var(--sat-text-dim)] line-clamp-2">{description}</p>}
          <div className="mt-auto pt-2 flex flex-wrap gap-x-6 gap-y-1 items-center">
            <div className="sat-label">{formatDate(date)}</div>
            {location && <div className="flex items-center gap-2 sat-label"><MapPin size={11}/> {location}</div>}
            {news_url && (
              <a href={news_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 sat-label sat-cyan hover:underline">
                DOSSIER <ExternalLink size={10} />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
